
import { Link } from "react-router-dom";
import ecricon from  '../icons/ecr.png';
const NavBar = ({ address }) => {
  return (
    <nav style={{position:'absolute',top:'0',left:'0',width:'100%'}} className="navbar navbar-expand-lg navbar-dark bg-dark mb-5">
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          <img src={ecricon} alt="ticky ticket" width="30" height="24"/>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
            <Link style={{ textDecoration: "none" }} to="/">
              <a className="nav-link" href="#">
                Home
              </a>
            </Link>
            </li>
            <li className="nav-item">
            <Link style={{ textDecoration: "none" }} to="/bookEvent">
              <a className="nav-link" href="#">
                Book Event
              </a>
            </Link>
            </li>
            <li className="nav-item">
            <Link style={{ textDecoration: "none" }} to="/swap">
              <a className="nav-link" href="#">
                Swap Token
              </a>
            </Link>
            </li>
            <li className="nav-item">
            <Link style={{ textDecoration: "none" }} to="/userticket">
              <a className="nav-link" href="#">
                Your Ticket
              </a>
            </Link>
            </li>
            <li  className="nav-item">
              <a className="nav-link" href="#">
                Address: {address ? address : "Address Not Found"}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
